import { StyleSheet } from 'react-native-unistyles';
import Avatar from '@/components/Custom/Avatar';
import Box from '@/components/UI/Box';
import Text from '@/components/UI/Text';
import { type FragmentOf, graphql, readFragment } from '@/gql/graphql';

export const EventBannerItemFragment = graphql(/* GraphQL */ `
  fragment EventBannerItem on event_team {
    score
    team {
      id
      avatar_id
      home_primary_color
      title
    }
  }
`);

export default function EventBannerItem({
  fragment,
  index,
  hideScore = false,
}: {
  fragment: FragmentOf<typeof EventBannerItemFragment> | undefined;
  index: number;
  hideScore?: boolean;
}) {
  const item = readFragment(EventBannerItemFragment, fragment);

  return (
    <Box direction="horizontal" px="xl" flex>
      <Box direction="horizontal" align="center" space="md" flex>
        <Box
          alignItems="center"
          justifyContent="center"
          style={style.avatarContainer}
          py="xl"
        >
          <Avatar
            id={item?.team.avatar_id || ''}
            size="lg"
            color={item?.team.home_primary_color || ''}
            name={item?.team.title || ''}
          />
          <Text
            position="absolute"
            bottom={0}
            variant="typographySecondary"
            size="2xs"
            numberOfLines={1}
          >
            {index ? 'HOME' : 'AWAY'}
          </Text>
        </Box>

        <Box
          direction="vertical"
          flex
          borderTopRightRadius={16}
          borderBottomRightRadius={16}
        >
          <Text bold numberOfLines={2} variant="white" style={style.title}>
            {item?.team.title}
          </Text>
        </Box>
      </Box>
      {!hideScore ? (
        <Box align="center" justify="center" minWidth={40}>
          <Text bold numberOfLines={1} variant="white" style={style.score}>
            {item?.score}
          </Text>
        </Box>
      ) : null}
    </Box>
  );
}

const style = StyleSheet.create((theme) => ({
  avatarContainer: {
    height: '100%',
  },
  score: {
    fontSize: {
      base: theme.fontSize['3xl'],
      lg: theme.fontSize['4xl'],
    },
  },
  title: {
    fontSize: {
      base: theme.fontSize['2xl'],
      lg: theme.fontSize['3xl'],
    },
  },
}));
